export const travelSafetyBottomFeatures = [
    {
        id: '1',
        title: 'Explore Freely, Stay Connected',
        content: "When you're exploring alone, having a safety net matters. Your location is shared in real time, so friends and family can check in without disrupting your adventure.",
        imgName: 'earth'
    },
    {
        id: '2',
        title: 'Works Anywhere, Even in Remote Locations ',
        content: "Device Tracker Plus runs on minimal data and works internationally, keeping you connected no matter where your journey takes you.",
        imgName: 'checkCircleIcon'
    },
    {
        id: '3',
        title: 'Avoid Getting Lost or Separated',
        content: "Meeting up with travel companions? Use live location sharing and Google Maps directions to find each other easily, even in unfamiliar cities.",
        imgName: 'mobilePhoneIcon'
    },
    {
        id: '4',
        title: 'No Intrusive Tracking, Just Peace of Mind',
        content: "Location sharing is a tool for you to stay safe without feeling monitored. You’re in control of who sees your location and when.",
        imgName: 'eye'
    },
];